var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { ApplicationContext } from '../../../../ApplicationContext';
import Signals from '../../../../signals/Signals';
import AssetServiceEntryOverlay from './AssetServiceEntryOverlay';
import AssignSchemaToAssetOverlay from '../../ServiceEntries/AssignSchemaToAssetOverlay';
import AssetServiceSchemaRow from './AssetServiceSchemaRow';
import ServiceAssetSchemaCollection from '../../../../collections/services/ServiceAssetSchemaCollection';
import GetServiceAssetSchemasCommand from '../../../../commands/services/GetServiceAssetSchemasCommand';
import GetServiceSchemasCommand from '../../../../commands/services/GetServiceSchemasCommand';
import RemoveSchemaFromAssetCommand from '../../../../commands/services/RemoveSchemaFromAssetCommand';
import CreateManualServiceEntryOverlay from '../../ServiceEntries/CreateManualServiceEntryOverlay';
/**
 *
 * @param props
 * @return {*}
 * @constructor
 */
var AssetServiceSchemas = /** @class */ (function (_super) {
    __extends(AssetServiceSchemas, _super);
    /**
     *
     * @param props
     */
    function AssetServiceSchemas(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { serviceAssetSchemaCollection: new ServiceAssetSchemaCollection() };
        _this.onRemoveSchemaFromAsset = _this.onRemoveSchemaFromAsset.bind(_this);
        _this.onAssignSchemaToAsset = _this.onAssignSchemaToAsset.bind(_this);
        _this.onNewServiceEntry = _this.onNewServiceEntry.bind(_this);
        return _this;
    }
    /**
     *
     */
    AssetServiceSchemas.prototype.componentDidMount = function () {
        this.componentInitialize();
    };
    /**
     *
     * @param prevProps
     * @param prevState
     * @param snapshot
     */
    AssetServiceSchemas.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
        if (prevProps.assetModel !== this.props.assetModel) {
            this.componentInitialize();
        }
    };
    /**
     *
     */
    AssetServiceSchemas.prototype.componentInitialize = function () {
        var _a = this.context, session = _a.session, serviceSchemaCollection = _a.serviceSchemaCollection;
        var assetModel = this.props.assetModel;
        var serviceAssetSchemaCollection = this.state.serviceAssetSchemaCollection;
        var user = session.user;
        new GetServiceAssetSchemasCommand().execute(user.organisation, assetModel, serviceAssetSchemaCollection);
        new GetServiceSchemasCommand().execute(user, serviceSchemaCollection);
    };
    /**
     *
     * @return {*}
     */
    AssetServiceSchemas.prototype.render = function () {
        var _this = this;
        var serviceSchemaCollection = this.context.serviceSchemaCollection;
        var serviceAssetSchemaCollection = this.state.serviceAssetSchemaCollection;
        try {
            return (React.createElement("div", { className: "w-100" },
                React.createElement("div", { className: "d-flex w-100 justify-content-end" },
                    React.createElement("button", { className: "btn btn-primary", onClick: this.onAssignSchemaToAsset },
                        React.createElement("span", { className: "fe fe-plus" }),
                        " ",
                        React.createElement(FormattedMessage, { id: "asset.detail.serviceschema.add.new" }))),
                React.createElement("hr", null),
                React.createElement("div", { className: "d-flex flex-wrap w-100" }, serviceAssetSchemaCollection.filtered.map(function (serviceAssetSchemaModel) {
                    return React.createElement(AssetServiceSchemaRow, { key: serviceAssetSchemaModel.assetId + ' ' + serviceAssetSchemaModel.schemaId, serviceAssetSchemaModel: serviceAssetSchemaModel, serviceSchemaCollection: serviceSchemaCollection, onRemove: _this.onRemoveSchemaFromAsset });
                }))));
        }
        catch (error) {
            console.log(error);
        }
        return null;
    };
    /**
     *
     */
    AssetServiceSchemas.prototype.onAssignSchemaToAsset = function () {
        var serviceAssetSchemaCollection = this.state.serviceAssetSchemaCollection;
        Signals.ShowOverlay.dispatch(React.createElement(AssignSchemaToAssetOverlay, { assetModel: this.props.assetModel, serviceAssetSchemaCollection: serviceAssetSchemaCollection }));
    };
    /**
     *
     * @param serviceAssetSchemaModel
     */
    AssetServiceSchemas.prototype.onRemoveSchemaFromAsset = function (serviceAssetSchemaModel) {
        var _a = this.props, intl = _a.intl, assetModel = _a.assetModel;
        var serviceAssetSchemaCollection = this.state.serviceAssetSchemaCollection;
        var _b = this.context, session = _b.session, serviceSchemaCollection = _b.serviceSchemaCollection;
        var schemaModel = serviceSchemaCollection.findById(serviceAssetSchemaModel.schemaId);
        var values = { assetId: assetModel.id, schemaName: schemaModel.name };
        //title, body, confirmText = 'Ok', cancelText = 'Cancel', onConfirm = null, onCancel = null
        Signals.ShowConfirmModal.dispatch(intl.formatMessage({ id: 'asset.schema.remove.confirm.title' }, values), intl.formatMessage({ id: 'asset.schema.remove.confirm.body' }, values), intl.formatMessage({ id: 'asset.schema.remove.confirm.yes' }, values), intl.formatMessage({ id: 'asset.schema.remove.confirm.no' }, values), function () {
            var command = new RemoveSchemaFromAssetCommand();
            command.execute(session.user.organisation, assetModel, serviceAssetSchemaModel, serviceAssetSchemaCollection, intl);
        });
    };
    /**
     *
     */
    AssetServiceSchemas.prototype.onNewServiceEntry = function () {
        var serviceAssetSchemaCollection = this.state.serviceAssetSchemaCollection;
        Signals.ShowOverlay.dispatch(React.createElement(CreateManualServiceEntryOverlay, { assetModel: this.props.assetModel, serviceAssetSchemaCollection: serviceAssetSchemaCollection }));
    };
    /**
     *
     */
    AssetServiceSchemas.prototype.onViewServiceEntry = function () {
        Signals.ShowOverlay.dispatch(React.createElement(AssetServiceEntryOverlay, { assetModel: this.props.assetModel }));
    };
    AssetServiceSchemas.defaultProps = {
        className: ''
    };
    AssetServiceSchemas = __decorate([
        observer
    ], AssetServiceSchemas);
    return AssetServiceSchemas;
}(React.Component));
AssetServiceSchemas.contextType = ApplicationContext;
export default injectIntl(AssetServiceSchemas);
